export function loadChunk(fn, retriesLeft = 2, interval = 1000) {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error) => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            reject(error);
            return;
          }

          loadChunk(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });
}
